/* BASIQ · Botón de compra (AJAX + carrito lateral + stock bajo) */
(function () {
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openCartDrawer() {
    /* 1º el carrito lateral de BASIQ */
    if (window.BasiqCart && typeof window.BasiqCart.open === 'function') {
      window.BasiqCart.open();
      return true;
    }
    var basiq = document.querySelector('[data-basiq-cart]');
    if (basiq) {
      document.dispatchEvent(new CustomEvent('basiq:cart:open'));
      return true;
    }
    /* 2º el del tema, por si acaso */
    var drawer = document.querySelector('cart-drawer-component, cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    }
    var trigger = document.querySelector('[data-cart-drawer-trigger], [aria-controls*="cart-drawer"], button.header-actions__cart-icon');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  function setup(el) {
    if (!el || el.dataset.ready === '1') return;
    el.dataset.ready = '1';

    var root = el.closest('[data-bp]') || document;
    var form = document.getElementById(el.getAttribute('data-form'));
    var btn = el.querySelector('[data-buy-btn]');
    var label = el.querySelector('[data-buy-label]');
    var errEl = el.querySelector('[data-buy-error]');
    var stockEl = el.querySelector('[data-buy-stock]');
    if (!form || !btn) return;

    var T = {
      add: el.getAttribute('data-t-add'),
      sold: el.getAttribute('data-t-sold'),
      added: el.getAttribute('data-t-added'),
      error: el.getAttribute('data-t-error')
    };
    var after = el.getAttribute('data-after') || 'drawer';
    var mode = el.getAttribute('data-stock-mode') || 'auto';
    var threshold = parseInt(el.getAttribute('data-stock-threshold'), 10) || 10;
    var available = el.getAttribute('data-available') === 'true';
    var busy = false;

    var inv = {};
    var invEl = el.querySelector('[data-buy-inv]');
    if (invEl) {
      try { inv = JSON.parse(invEl.textContent); } catch (e) {}
    }

    function setAvailable(a) {
      available = a;
      btn.disabled = !a;
      btn.classList.toggle('is-sold', !a);
      if (label && !busy) label.textContent = a ? T.add : T.sold;
    }

    function updateStock(id) {
      if (!stockEl) return;
      var show = false;
      if (mode === 'always') {
        show = available;
      } else if (mode === 'auto') {
        var d = inv[id];
        show = !!(d && d.t && d.q > 0 && d.q <= threshold);
      }
      stockEl.hidden = !show;
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || T.error;
      errEl.hidden = false;
    }

    function add() {
      busy = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (errEl) errEl.hidden = true;

      var fd = new FormData(form);

      fetch(ROOT_URL + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            return j;
          });
        })
        .then(function (added) {
          return fetch(ROOT_URL + 'cart.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return { added: added, cart: cart }; });
        })
        .then(function (res) {
          var cart = res.cart;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-done');
          if (label) label.textContent = T.added;

          /* Avisa a nuestros bloques (descuento por cantidad) */
          document.dispatchEvent(new CustomEvent('bp:cart-updated', { detail: { cart: cart } }));

          /* Avisa al tema (contador del carrito, carrito lateral) */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'bp-buy',
              data: {
                source: 'bp-buy',
                itemCount: cart.item_count,
                productId: res.added && res.added.product_id
              }
            }
          }));

          if (after === 'cart') {
            window.location.href = ROOT_URL + 'cart';
            return;
          }
          if (after === 'drawer') {
            if (!openCartDrawer()) {
              window.location.href = ROOT_URL + 'cart';
              return;
            }
          }

          setTimeout(function () {
            btn.classList.remove('is-done');
            busy = false;
            if (label) label.textContent = available ? T.add : T.sold;
          }, 1600);
        })
        .catch(function (j) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          busy = false;
          showError(j && (j.description || j.message));
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !available) return;
      add();
    });

    root.addEventListener('bp:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      setAvailable(!!v.available);
      updateStock(v.id);
      if (errEl) errEl.hidden = true;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bp-buy]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bp-buy]').forEach(setup);
  });
})();
